var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('a',{staticClass:"button",attrs:{"href":"javascript:void(0);"},on:{"click":_vm.onClick}},[_vm._v("了解更多 >")])])
}
var staticRenderFns = []

export { render, staticRenderFns }